import { render } from "./Feriados.vue?vue&type=template&id=2dd1d8fe&scoped=true"
import script from "./Feriados.vue?vue&type=script&lang=js"
export * from "./Feriados.vue?vue&type=script&lang=js"

import "./Feriados.vue?vue&type=style&index=0&id=2dd1d8fe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd1d8fe"]])

export default __exports__